import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import { PostStatus } from '@tribeplatform/gql-client/types';
import { useReplies } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { Link } from '@tribeplatform/react-ui-kit/Link';
import { T } from '../i18n';
import { ReplyBar } from '../Post/ReplyBar';
import { Reply } from './Reply';
export const ReplyList = ({ post, readonly, className, }) => {
    var _a;
    const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useReplies({
        variables: {
            limit: 5,
            postId: post === null || post === void 0 ? void 0 : post.id,
            reverse: true,
        },
        fields: {
            owner: {
                member: { profilePicture: 'basic', badges: 'all' },
            },
            embeds: 'basic',
            mentions: 'basic',
            attachments: 'basic',
            authMemberProps: 'all',
            reactions: { fields: 'all', variables: { limit: 10 } },
            replies: {
                fields: {
                    owner: {
                        member: { profilePicture: 'basic', badges: 'all' },
                    },
                    embeds: 'basic',
                    mentions: 'basic',
                    attachments: 'basic',
                    authMemberProps: 'all',
                    reactions: { fields: 'all', variables: { limit: 10 } },
                },
                variables: {
                    limit: 2,
                    reverse: true,
                },
            },
        },
        useInfiniteQueryOptions: {
            refetchOnMount: 'always',
            enabled: !!(post === null || post === void 0 ? void 0 : post.id),
        },
    });
    const canReply = !readonly && post && (post === null || post === void 0 ? void 0 : post.status) === PostStatus.PUBLISHED;
    if (isLoading) {
        return (_jsx(Card, { className: clsx('mt-5', className), children: _jsx(Card.Content, { className: "pb-3 sm:pb-3 px-5 flex flex-col space-y-6", children: [...Array(3)].map((_e, i) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsxs("div", { className: "animate-pulse flex space-s-3", children: [_jsx("div", { className: "rounded-full h-10 w-10 bg-skeleton " }, void 0), _jsxs("div", { className: "flex-1 space-y-1", children: [_jsx("div", { className: "flex items-center justify-between mb-3", children: _jsx("div", { className: "h-4 bg-skeleton rounded-full w-4/6" }, void 0) }, void 0), _jsx("div", { className: "flex items-center justify-between mb-3", children: _jsx("div", { className: "h-4 bg-skeleton rounded-full w-full" }, void 0) }, void 0)] }, void 0)] }, i))) }, void 0) }, void 0));
    }
    const { nodes: replies } = simplifyPaginatedResult(data);
    return (_jsx(Card, { className: clsx('mt-5', className), children: _jsx(Card.Content, { className: "flex flex-col space-y-6 px-5 empty:hidden", children: (replies === null || replies === void 0 ? void 0 : replies.length) > 0 || canReply ? (_jsxs(_Fragment, { children: [hasNextPage && (_jsxs("div", { className: "flex justify-between", children: [_jsxs("div", { className: "flex items-center space-s-3", children: [_jsx(Link, { variant: "inherit", className: "text-sm leading-5 font-medium text-content-subdued", onClick: () => {
                                            fetchNextPage();
                                        }, children: _jsx(T, { id: "Reply.ReplyList.MoreRepliesButtonText", defaultMessage: "View more replies" }, void 0) }, void 0), isFetching && _jsx(SpinnerIcon, { className: "animate-spin" }, void 0)] }, void 0), _jsx("div", { className: "text-content-subdued text-sm leading-5 font-normal", children: _jsx(T, { id: "Reply.ReplyList.LoadedOfTotalRepliesText", defaultMessage: "{loaded_replies} of {total_replies}", values: {
                                        loaded_replies: replies.length,
                                        total_replies: post === null || post === void 0 ? void 0 : post.repliesCount,
                                    } }, void 0) }, void 0)] }, void 0)), _jsxs("div", { className: "relative flex flex-col space-y-6", children: [(_a = replies === null || replies === void 0 ? void 0 : replies.reverse()) === null || _a === void 0 ? void 0 : _a.map(reply => (_jsx(Reply, { reply: reply, post: post, canReply: true, readonly: readonly, context: "post" }, reply.id))), canReply && _jsx(ReplyBar, { post: post }, void 0), _jsx("div", { className: "absolute -z-10 w-[2px] ms-[-1px] top-1 start-6 bottom-0 bg-surface-pressed" }, void 0)] }, void 0)] }, void 0)) : null }, void 0) }, void 0));
};
//# sourceMappingURL=ReplyList.js.map